import { createTheme, Theme } from '@mui/material/styles';

export const lightTheme: Theme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: '#f5f6fa',
        },
        primary: {
            main: '#6c89b5',
        },
        text: {
            primary: '#1e1e1e',
        },
    },
    typography: {
        fontFamily: 'Segoe UI, sans-serif',
    },
});

export const darkTheme: Theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#1e1e1e',
            paper: '#2c2c2c',
        },
        primary: {
            main: '#90caf9',
        },
        text: {
            primary: '#ffffff',
        },
    },
    typography: {
        fontFamily: 'Segoe UI, sans-serif',
    },
});
